<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('处理状态')" prop="processStatus">
                <a-select :placeholder="$t('请选择')+$t('处理状态')" style="width: 100%" v-model="queryParam.processStatus" allowClear>
                  <a-select-option
                    v-for="(item, index) in this.customDict.AuditStatusEnum"
                    :value="item.type"
                    :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('投诉原因')" prop="reasonId">
                <a-select :placeholder="$t('请选择')+$t('投诉原因')" style="width: 100%" v-model="queryParam.reasonId" allowClear>
                  <a-select-option
                    v-for="(item, index) in this.reasonList"
                    :value="item.id"
                    :key="index">
                    {{ item.title }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker
                  style="width: 100%"
                  v-model="queryParam.createBeginTime"
                  :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker
                  style="width: 100%"
                  v-model="queryParam.createEndTime"
                  :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                  valueFormat="YYYY-MM-DD HH:mm:ss"
                  allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
          <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
            <img alt="example" style="width: 100%" :src="previewUrl" />
          </a-modal>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleExport" v-hasPermi="['community:communityreport:export']">
          <a-icon type="download" />{{ $t('导出') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :reason-list="reasonList"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: 2000 }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="type" slot-scope="text, record">
          <custom-dict-tag :options="customDict.ReportTypeEnum" :color="true" :value="record.type"/>
        </span>
        <span slot="processStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.AuditStatusEnum" :value="record.processStatus"/>
        </span>
        <span slot="imgUrlList" slot-scope="text, record">
          <template v-for="(img, index) in record.imgUrlList">
            <img v-if="img" :src="img" style="width:60px;height:62px;" @click="handleRecordPreview(img)" alt="none"/>
          </template>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['community:communityreport:audit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.processStatus===1" v-hasPermi="['community:communityreport:audit']">
            <a-icon type="edit" />{{ $t('处理') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCommunityReport, listCommunityReport, delCommunityReport } from '@/api/community/report'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { listCommunityReportReason } from '@/api/community/reportReason'

export default {
  name: 'CommunityReport',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      reasonList: [],
      // 查询参数
      queryParam: {
        type: 6,
        processStatus: undefined,
        reasonId: undefined,
        processResult: undefined,
        imgUrls: undefined,
        evaluation: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('投诉用户编号'),
          dataIndex: 'targetId',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('投诉用户名称'),
          dataIndex: 'targetName',
          width: 130,
          align: 'center'
        },
        {
          title: this.$t('投诉次数'),
          dataIndex: 'reportNum',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('投诉内容'),
          dataIndex: 'content',
          width: 200,
          align: 'center'
        },
       /* {
          title: this.$t('投诉类型'),
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          width: 100,
          align: 'center'
        }, */
        {
          title: this.$t('处理状态'),
          dataIndex: 'processStatus',
          scopedSlots: { customRender: 'processStatus' },
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('投诉图片'),
          dataIndex: 'imgUrlList',
          scopedSlots: { customRender: 'imgUrlList' },
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          width: 160,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          fixed: 'right',
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getReasonList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 查询举报投诉列表 */
    getList () {
      this.loading = true
      pageCommunityReport(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    getReasonList () {
      this.loading = true
      listCommunityReportReason({ 'type': 6 }).then(response => {
        this.reasonList = response.data
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        type: 6,
        processStatus: undefined,
        reasonId: undefined,
        processResult: undefined,
        imgUrls: undefined,
        evaluation: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      const reqData = { 'idList': this.ids }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delCommunityReport(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message, 3)
            })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('community/admin/report/export',
            that.queryParam
            , `举报投诉_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
